import { render, staticRenderFns } from "./Tablepersontofilmsdialog.vue?vue&type=template&id=01f0aff2"
import script from "./Tablepersontofilmsdialog.vue?vue&type=script&lang=js"
export * from "./Tablepersontofilmsdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports